const fetchHomeType = 'FETCH_HOME';
const getHomeType = 'GET_HOME';

const initialState = { home: [], isLoading: false };

export const homeActions = {

    fetchHome: () => async (dispatch, getState) => {
        dispatch({ type: fetchHomeType });
    },

    getHome: () => async (dispatch, getState) => {
        dispatch({ type: fetchHomeType });
        const response = await fetch(`api/home`);
        const home = await response.json();
        console.log(home);
        dispatch({ type: getHomeType, home });
    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case fetchHomeType:
            return {  ...state,  isLoading: true };

        case getHomeType:
            return { ...state, home: action.home, isLoading: false };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/home.js